// [LOADINGS]: a pollutant missing from a subcatchment's row is NOT the same
// as zero — real SWMM falls back to its own antecedent-dry-time buildup
// formula instead. This port's engine doesn't model that fallback yet
// (data/editor side only).

import { readPairSection, writePairSection } from "./pairSection.ts";

export interface Loading {
  subcatchment: string;
  pollutant: string;
  initialBuildup: number;
}

export function readLoadings(
  raw: ReadonlyMap<string, string[][]>,
  warnings?: Set<string>
): Loading[] {
  return readPairSection(raw, "LOADINGS", "Initial Buildup", warnings).map((r) => ({
    subcatchment: r.subcatchment,
    pollutant: r.category,
    initialBuildup: r.value,
  }));
}

export function writeLoadings(
  raw: ReadonlyMap<string, string[][]>,
  loadings: Loading[]
): Map<string, string[][]> {
  return writePairSection(
    raw,
    "LOADINGS",
    loadings.map((l) => ({
      subcatchment: l.subcatchment,
      category: l.pollutant,
      value: l.initialBuildup,
    }))
  );
}

export function loadingsFor(loadings: Loading[], subcatchment: string): Loading[] {
  return loadings.filter((l) => l.subcatchment === subcatchment);
}
